import theme from '../../../lib/theme';
import { StoriesBlockProps } from './StoriesBlock';

const { layouts, scale, media, colors, corners } = theme;

export default ({
  hideAds,
}: StoriesBlockProps) => ({
  container: {
    ...layouts.spacedColumn('m'),
  },

  articles: {
    ...layouts.column,

    '& > *': {
      marginBottom: scale.l,
    },

    '& > *:last-child': {
      marginBottom: 0,
    },

    [media.l.up]: {
      ...layouts.row,

      alignItems: 'stretch',

      '& > *': {
        marginBottom: 0,
        marginRight: scale.m,
      },

      '& > *:last-child': {
        marginRight: 0,
      },
    },
  },

  adContainer: {
    flex: 'auto',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },

  headingContainer: {
    ...layouts.spacedColumn('xs'),

    width: '100%',
    maxWidth: 903,
  },

  asideContainer: {
    ...layouts.spacedColumn('m'),
    display: 'none',

    [media.l.up]: {
      display: !hideAds ? 'flex' : 'none',
      width: '100%',
      maxWidth: 360,
    },

    // '&.full-height': {
    //   backgroundColor: colors.travel360.primary_light,
    // }
  },

  articlesLeft: {
    ...layouts.spacedColumn('m'),
    flex: 'auto',
    width: '100%',
  },

  articlesList: {
    ...layouts.spacedColumn('m'),

    alignItems: 'stretch',
    justifyContent: 'stretch',
  },

  icon: {
    fontSize: 40,
  },

  loading: {
    backgroundImage:
      "url('https://images.startsat60.com/frontend/loading-spinner-sas.gif')",
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    width: 50,
    height: 10,
  },
  loadingButton: {
    backgroundColor: 'transparent !important',
    borderColor: `${colors.sas.primary} !important`,
    '&:hover': {
      backgroundColor: 'transparent !important',
      borderColor: `${colors.sas.primary} !important`,
    }
  },
  recirculationAd: {
    padding: scale.xs,
    borderRadius: corners.l,
    [media.s.down]: {
      marginLeft: `-${scale.xs} !important`,
      marginRight: `-${scale.xs} !important`,
    },
  },
});
